<template>
  <b-container class="row">
    <b-col>
      <dl class="row">
        <dt class="col-sm-6">Name</dt>
        <dd class="col-sm-6">{{ student.firstName }} {{ student.lastName }}</dd>
        <dt class="col-sm-6">Asurite</dt>
        <dd class="col-sm-6">{{ student.asuriteId }}</dd>
      </dl>
    </b-col>
    <b-col>
      <dl class="row" v-if="activePlan">
        <dt class="col-sm-6">Academic Career</dt>
        <dd class="col-sm-6">{{ activePlan.academicCareer }}</dd>
        <dt class="col-sm-6">Academic Program</dt>
        <dd class="col-sm-6">{{ activePlan.academicProgram }}</dd>
        <dt class="col-sm-6">Academic Plan</dt>
        <dd class="col-sm-6">{{ activePlan.academicPlan }} - {{ activePlan.academicPlanDescription }}</dd>
        <dt class="col-sm-6">Admit Term</dt>
        <dd class="col-sm-6">{{ activePlan.termAdmitted }}</dd>
      </dl>
    </b-col>
  </b-container>
</template>

<script>
export default {
  data() {
    return {};
  },

  props: {
    student: {
      type: Object,
      required: true
    }
  },

  computed: {
    activePlan() {
      if (this.student) {
        const studentPlans = this.student.studentPlans;
        if (this.student.studentPlans) {
          const latestTerm = studentPlans.sort((a, b) =>
            b.termCode.localeCompare(a.termCode)
          )[0].termCode;

          return this.student.studentPlans.find(
            plan => plan.termCode === latestTerm && plan.primaryRecord === "Y"
          );
        }
      }
    }
  }
};
</script>

<style scoped></style>
